import { createAsyncThunk } from '@reduxjs/toolkit';
import MarketplaceCategoriesResource from 'api/service/MarketplaceCategoriesResource';

export const listProducts = createAsyncThunk('marketplace/listProducts', async (initialData, { rejectWithValue }) => {
  const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
  const { categoryId } = initialData;
  const { status, data } = await marketplaceCategoriesResource.category(categoryId).products();
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Category products not found.');
});
